import React from "react";
import { Panel } from "components/bootstrap";
import DocumentationLink from "components/support/DocumentationLink";
import DocsHelper from "util/DocsHelper";
export default function SidebarPermissions() {
  return /* @__PURE__ */ React.createElement(Panel, { bsStyle: "info", header: /* @__PURE__ */ React.createElement("span", null, "AWS Policy Permissions") }, /* @__PURE__ */ React.createElement("p", null, "Please refer to the", " ", /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.AWS_KINESIS_CLOUDWATCH_INPUT, text: "official documentation" }), " for information on required AWS permissions.", /* @__PURE__ */ React.createElement("br", null)));
}
